// extracted by mini-css-extract-plugin
export var alignCenter = "_ab-d";
export var bannerShown = "_ab-6";
export var buttonContent = "_ab-0";
export var cardList = "_ab-1";
export var centerContent = "_ab-2";
export var chevron = "_ab-3";
export var closePanelButton = "_ab-k";
export var conversationContextContainer = "_ab-l";
export var conversationDetailContainer = "_ab-4";
export var detailWrapper = "_ab-7";
export var dropdownButton = "_ab-e";
export var dropdownTitle = "_ab-9";
export var fullHeight = "_ab-5";
export var hidden = "_ab-a";
export var icon = "_ab-b";
export var mergeSuggestionWrapper = "_ab-m";
export var panel = "_ab-i";
export var portalButtonsWrapper = "_ab-c";
export var right = "_ab-j";
export var tableSummaryContainer = "_ab-8";
export var tableSummaryHeader = "_ab-g";
export var threeDotsButton = "_ab-f";
export var wide = "_ab-h";